angular.module("app").directive("dateTimePicker", [
    function ($rootScope) {
        var defaultFormat = "MM/DD/YYYY, HH:mm:ss";

        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                pick12HourFormat: '@',
                language: '@',
                format: '@',
                initValue: '=',
                useCurrent: '@',
                location: '@',
                callback: "&cb"
            },
            link: function (scope, elem, attrs) {
                scope.format = scope.format || defaultFormat;

                if (attrs.ngModel === "vm.created_at") {
                    !!scope.initValue.created_at && (scope.initValue.created_at = moment(new Date(scope.initValue.created_at)).format(scope.format));
                } else  if(!!scope.initValue) {
                    if(angular.isDefined(attrs.from)) {
                        !!scope.initValue.dateTimeFrom && (scope.initValue.dateTimeFrom = moment(new Date(scope.initValue.dateTimeFrom)).format(scope.format));
                    }
                    else {
                        !!scope.initValue.dateTimeTo && (scope.initValue.dateTimeTo = moment(new Date(scope.initValue.dateTimeTo)).format(scope.format));
                    }
                }

                var callBack = scope.callback();

                $(elem).datetimepicker({
                    pick12HourFormat: scope.pick12HourFormat,
                    language: scope.language,
                    useCurrent: scope.useCurrent,
                    format: scope.format
                });

                //Local event change
                $(elem).on("dp.change", function (options) {
                    var dateTime = "",
                        dateTimeToSave = undefined;

                    if(!!options.date) {
                        dateTime = options.date.format(scope.format);
                        dateTimeToSave = options.date.format();
                    }

                    if(angular.isDefined(attrs.from)) {
                        return callBack.call({from: true}, dateTime, dateTimeToSave);
                    }

                    callBack.call({}, dateTime, dateTimeToSave);
                });

                $(elem).on('blur', function () {

                })
            }
        };
    }
]);